import { BASE_PATH_API, TIMEOUT_TIME, STAGE_DIRNAME, BASE_PATH_API_DEV } from 'constants/general';
import axios from 'axios';
import { decodeStorage } from 'pages/Header/Content/functions/storageBase64';

export async function putRequestCard({ Tienda, Nombre, APaterno, AMaterno, Genero, FechaNacimiento, Telefono, RFC, Domicilio, CP, Colonia,
    Ciudad, Estado, TipoVivienda, MontoRenta, TiempoResAnio, TiempoResMes, Nodependientes, Celular, Empresa, TipoEmpresa, TelEmpresa, Ext,
    DireccionEmpleo, CPEmp, ColoniaEmp, MunicipioEmp, EstadoEmp, Ocupacion, TiempoEmpAnio, TiempoEmpMes, Ingmensual, OtroIngresos, FuenteOtroIngresos,
    Email, STarjeta, Digitos, SHipotecario, SAutomotriz, Autorizacion }) {

    let apiURL
    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/credito-sears/v1/requests/short`
    }else{
        apiURL = `${BASE_PATH_API}/credito-sears/v1/requests/short`
    }

    const accessToken = decodeStorage('access_token');

    const raw = JSON.stringify({
        "Comp": "076",
        "Tienda": Tienda,
        "Nombre": Nombre,
        "APaterno": APaterno,
        "AMaterno": AMaterno,
        "Genero": Genero,
        "FechaNacimiento": FechaNacimiento,
        "Telefono": Telefono,
        "RFC": RFC,
        "Domicilio": Domicilio,
        "CP": CP,
        "Colonia": Colonia,
        "Ciudad": Ciudad,
        "Estado": Estado,
        "TipoVivienda": TipoVivienda,
        "MontoRenta": MontoRenta,
        "TiempoResAnio": TiempoResAnio,
        "TiempoResMes": TiempoResMes,
        "Nodependientes": Nodependientes,
        "Celular": Celular,
        "Empresa": Empresa,
        "TipoEmpresa": TipoEmpresa,
        "TelEmpresa": TelEmpresa,
        "Ext": Ext,
        "DireccionEmpleo": DireccionEmpleo,
        "CPEmp": CPEmp,
        "ColoniaEmp": ColoniaEmp,
        "MunicipioEmp": MunicipioEmp,
        "EstadoEmp": EstadoEmp,
        "Ocupacion": Ocupacion,
        "TiempoEmpAnio": TiempoEmpAnio,
        "TiempoEmpMes": TiempoEmpMes,
        "Ingmensual": Ingmensual,
        "OtroIngresos": OtroIngresos,
        "FuenteOtroIngresos": FuenteOtroIngresos,
        "Email": Email,
        "STarjeta": STarjeta,
        "Digitos": Digitos,
        "SHipotecario": SHipotecario,
        "SAutomotriz": SAutomotriz,
        "Autorizacion": Autorizacion
    })

    const config = {
        method: 'put',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        crossdomain: true,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${accessToken}`
        },
        data: raw
    };

    return await axios(config)
        .then(res => {
            const {
                headers,
                status,
                data
            } = res
            // console.log("ok-->", data)
            return {
                'headers': headers,
                'statusCode': status,
                'data': data,
                'error': ''
            }
            // return data
        })
        .catch(error => {
            // console.log("error--->",error.response?.data?.msg)
            return {
                'headers': '',
                'statusCode': error.request.status,
                'data': error.request.response,
                'error': error.response?.data?.msg

            }
        })
}